import{Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';



@Injectable({
    providedIn: 'root'
})

export class PropertiesTowers{

    private boolBtnFormIncident = new BehaviorSubject<number>(null);
    private dataFormIncident = new BehaviorSubject<[any,number]>([null,0])
    private dataIncidentRecordModal = new BehaviorSubject<any>(null)
    private confirmUpdateFieldService = new BehaviorSubject<boolean>(false)
    private IsSelectAllSites = new BehaviorSubject<boolean>(false)

    private filtersParams = new BehaviorSubject<any>(null)
    private confirmRegisterDataMonitoring = new BehaviorSubject<boolean>(false)
    private saveOrUpdateDevices = new BehaviorSubject<boolean>(false)


    clickBtnAddDevice = this.saveOrUpdateDevices.asObservable()
    clickBtnFormIncident = this.boolBtnFormIncident.asObservable()
    listeningDataFormIncident = this.dataFormIncident.asObservable() 
    listeningIncidentRecordModal = this.dataIncidentRecordModal.asObservable()
    updateFildsServiceConfirm = this.confirmUpdateFieldService.asObservable() 
    IsSelectAllSites$ = this.IsSelectAllSites.asObservable()
    filtersParams$ = this.filtersParams.asObservable()
    confirmUpdateFieldService$ = this.confirmRegisterDataMonitoring.asObservable()


    setFiltersParam(data:any){
        this.filtersParams.next(data)
    }

    setValueAddOrUpdateDevice(value:boolean){   
        this.saveOrUpdateDevices.next(value)    
    }

    setConfirmFieldsServicesUpdate(value:boolean){
        this.confirmUpdateFieldService.next(value)
    }

    setConfirmRegisterMonitoring(value:boolean){
        this.confirmRegisterDataMonitoring.next(value)
    }

    setClickBtnFormIncident(value:number){
        this.boolBtnFormIncident.next(value)
    }

    setDataFormIncident(value:any,btnNumber:number){
        this.dataFormIncident.next([value,btnNumber])
    }

    sendIncidentRecordData(data: any){
        this.dataIncidentRecordModal.next(data)
    }
    setIsSelectedAllSites(value:boolean){
        this.IsSelectAllSites.next(value)
    }


    clearPropertiesData(){
        this.boolBtnFormIncident.next(0)
        this.dataFormIncident.next([null,0])
        this.dataIncidentRecordModal.next(null)
        


    }
    clearPropertiesDataFilters(){
        this.filtersParams.next(null)
    }

}